import { isMobileOnly } from 'react-device-detect';
import { useTheme } from '@mui/material';
import { colors, COLORS } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  return {
    root: {
      position: 'relative',
      '& svg': {
        width: 24,
        height: 24,
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        '& svg': {
          width: 18,
          height: 18,
        },
      },
    },
    mainButton: {
      backgroundColor: COLORS.DARK_GREY,
      backdropFilter: 'blur(6px)',
      borderRadius: 72,
      padding: '15px',
      boxSizing: 'border-box',
      //color: showPulseAnimation ? COLORS.ERROR : colors.white,
      display: 'flex',
      justifyContent: 'center',
      overflow: 'hidden',
      '&:hover': {
        backgroundColor: COLORS.BACKGROUND_COLOR,
      },
      '&.Mui-disabled': {
        backgroundColor: COLORS.DARK_GREY,
        //color: showPulseAnimation ? COLORS.ERROR : colors.white,
        opacity: 0.5,
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '11px',
      },
    },

    container: (active: boolean) => ({
      position: 'absolute',
      bottom: 0,
      height: active ? 154 : 56,
      overflow: 'hidden',
      transition: 'height 0.2s ease-in',
      borderRadius: 72,
      backgroundColor: COLORS.BACKGROUND_COLOR,
      border: `1px solid ${COLORS.NEW_LOGIN_GREY}`,
      boxSizing: 'border-box',
      width: 'calc(100% + 2px)',
      transform: 'translateX(50%) translateY(1px)',
      right: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: 1,
      px: 2,
      paddingBottom: '54px',

      '& svg, & hr': {
        opacity: active ? 1 : 0,
        transition: 'opacity 0s 0.05s',
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: active ? 110 : 42,
        paddingBottom: '40px',
        gap: 0.5,
      },
    }),
    deliver: {
      borderBottomWidth: '2px',
      borderColor: '#404040',
    },
    buttonWrapper: {
      display: ['none', 'flex'],
      justifyContent: 'center',
      alignItems: 'center',
      width: 'fit-content',
      height: 'fit-content',
    },
    warning: {
      backgroundColor: COLORS.ERROR,
      position: 'absolute',
      borderRadius: 72,
      padding: 2,
      width: 62,
      height: 62,
      boxSizing: 'border-box',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: 52,
        height: 52,
      },
    },
    content: {
      display: 'flex',
      gap: 4,
      flexDirection: 'column',
    },

    contentMobile: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    actions: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '24px',
    },
    actionsWrapperMobile: {
      width: '48%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    actionsMobile: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    button: (isActive = false) => ({
      p: '0 12px 8px 12px',
      color: colors.white,
      borderBottom: `4px solid ${isActive ? colors.white : '#666666'}`,
      borderRadius: 0,
      gap: 1,
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',

      '&.Mui-disabled': {
        color: colors.white,
        cursor: 'no-drop',
        pointerEvents: 'auto',
      },
    }),
    buttonText: {
      fontSize: '14px',
      lineHeight: '150%',
      letterSpacing: '2%',
      fontWeight: 500,
    },
    buttonTextMobile: {
      fontSize: '12px',
    },
    progress: {
      color: COLORS.WHITE,

      width: '28px !important',
      height: '28px !important',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '20px !important',
        height: '20px !important',
      },
    },
    scrollable: (isShareWebcam: boolean) => ({
      maxHeight: 'calc(100vh - 192px)',
      height: isShareWebcam ? 390 : 324,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        maxHeight: isMobileOnly ? 'calc(100vh - 146px)' : 'calc(100vh - 218px)',
      },
    }),
  };
};
